<template>
  <div v-if="tags.length">
    <hr class="separator-slim mx-6" />
    <div class="search-filter-box p-6">
      <h4 class="fs-20 font-medium mb-4">
        Good for...
      </h4>

      <checkbox
        v-for="tag in tags"
        :key="tag.value"
        v-model="options[`opt${tag.value}`]"
      >
        {{ tag.title }}
      </checkbox>
    </div>
  </div>
</template>

<script>
import Checkbox from '../../../components/core/Checkbox';
import ClearFiltersMixin from '../../../mixins/ClearFiltersMixin';

export default {
  mixins: [ClearFiltersMixin],
  components: {
    Checkbox,
  },
  data() {
    return {
      tags: [],
      options: null,
    };
  },
  mounted() {
    $.ajax({
      method: 'POST',
      url: '/',
      data: {
        action: 'zuBlu/public/getSearchTags',
        [window.Craft.csrfTokenName]: window.Craft.csrfTokenValue,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }).then((response) => {
      this.tags = JSON.parse(response);
      this.options = this.loadOptions();
    });
  },
  methods: {
    loadOptions() {
      const { filters } = this.$store.state;
      const selectedTags = filters.tags.split(',').map((x) => x);

      const options = this.tags.reduce((opts, tag) => {
        return Object.assign(opts, {
          [`opt${tag.value}`]: selectedTags.includes(tag.value.toString()),
        });
      }, {});

      return options;
    },
  },
  watch: {
    options: {
      deep: true,
      handler(options) {
        let result = [];

        for (const opt in options) {
          if (options[opt]) {
            result.push(opt.substring(3));
          }
        }

        this.$store.commit('setFilter', {
          name: 'tags',
          value: result.join(','),
        });

        this.$store.dispatch('loadSuppliers');
      },
    },
  },
};
</script>
